import { CALCULATOR_DATA_TEST_ID } from '../constants';
export function parseKeyToDataTest(component, value) {
  if (!value) {
    return "".concat(CALCULATOR_DATA_TEST_ID, "-").concat(component);
  }
  var parsed = value.replace(/\./g, '-').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  return "".concat(CALCULATOR_DATA_TEST_ID, "-").concat(component, "-").concat(parsed);
}